export const extractNameFromKey = (key?: string): string | undefined => (typeof key === 'string' ? key?.split(':')?.[1] : undefined);
